export default class ApiError {

    static DATA_FAILED = 4010;
    static DATA_NOT_FOUND = 4020;

    static AUTH_USER_LOCKED = 2060;
    static AUTH_USER_PASSWORD_EXPIRED = 2061;
    static AUTH_CURRENT_PASSWORD_INVALID = 2062;

    static PASSWORD_SHORT = 3000;
    static PASSWORD_WEAK = 3001;
    static PASSWORD_NOT_UNIQUE = 3002;

    static USER_EMAIL_EXISTS = 100;
    static PROJECT_CODE_EXISTS = 101;
    static NO_ACCESS_APPLICATION = 102;
}